import { FilterDatePicker } from "components/DatePicker/SingleDatePicker";
import AirlinePaginatedDropdown from "components/dropdowns/paginated/AirlinePaginatedDropdown";
import moment from "moment";
import React from "react";
import { Input } from "../../components";
import NumberInput from "components/NumberInput";
import { ButtonTertiary } from "components/Atoms/Button";

interface Props {
  onSearch: (flightNumber: number) => void
  airlineHasError: boolean
  flightNumberHasError: boolean

  airline: server.dto.Airline
  flightNumber: number
  departureDate: moment.Moment

  onAirlineChange: (airline: server.dto.Airline) => void
  onFlightNumberChange: (flightNumber: number) => void
  onDepartureDateChange: (date: moment.Moment) => void
}

const SearchFlight = (props: Props) => {
  const flightNumberInputRef = React.createRef<Input>();

  React.useEffect(() => {
    if (props.airline && flightNumberInputRef.current) {
      flightNumberInputRef.current.focus();
    }
  }, [props.airline]);

  return <div className="flex gap padding-larger radius card-floating-bg">
    <div className="grow1 flex-column">
      <div className="s1_gray s1_small">{RESX.Flight.Airline}</div>
      <AirlinePaginatedDropdown
        displayFriendyCodeInSelectedValue
        value={props.airline}
        onChange={airline => {
          props.onAirlineChange(airline)
        }}
        config={{
          isSearchable: true,
          hasError: props.airlineHasError,
          focusOnMount: true
        }}
      />
    </div>

    <div className="flex-column">
      <div style={{ width: 120 }} className="s1_gray s1_small">{RESX.Flight.FlightNumber}</div>
      <NumberInput
        // @ts-expect-error this expects a legacy ref but it still works
        innerRef={flightNumberInputRef}
        error={props.flightNumberHasError}
        placeholder="687"
        value={props.flightNumber}
        onChanged={number => props.onFlightNumberChange(number.value)}
        maxLength={4}
        canBeEmpty
        width={60}
        decimalPoints={0}
        onEnterPressed={nr => props.onSearch(nr.value)}
      />
    </div>

    <div className="flex-column">
      <div className="s1_gray s1_small">{RESX.Flight.Departure}</div>
      <FilterDatePicker
        minDate={moment.utc().startOf("day")}
        maxDate={moment(serverReference.constants.appointment.maxDate)}
        value={props.departureDate}
        onChange={props.onDepartureDateChange}
      />
    </div>

    <div className="flex-column justify-end">
      <ButtonTertiary
        label={RESX.GeneralLabels.Search}
        onClick={() => { props.onSearch(props.flightNumber); }}
      />
    </div>
  </div>;
};

export default SearchFlight;
